// //////////////////////////////////////////////////////////////////////// //
// /////////////////////////////// IMPORT ///////////////////////////////// //
// //////////////////////////////////////////////////////////////////////// //

import React from "react";
import { Link } from "react-router-dom";

// //////////////////////////////////////////////////////////////////////// //
// //////////////////////////////// APP /////////////////////////////////// //
// //////////////////////////////////////////////////////////////////////// //

export const NotFound = () => {

// //////////////////////////////////////////////////////////////////////// //
// //////////////////////////////// RETURN JSX //////////////////////////// //
// //////////////////////////////////////////////////////////////////////// //

    return(
        <>
            <p>
                <Link to="/login">GO TO LOGIN</Link>
            </p>
            <p>
                <Link to="/">GO TO MAIN</Link>
            </p>
            <p>Sorry, nothing here...</p>
        </>
    );
}